export function CheckCircleFillIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM8.79438 3.87488C9.03682 4.06535 9.06958 4.40504 8.86754 4.6336L5.67089 8.25L3.23934 6.6126C2.98253 6.43966 2.92305 6.10321 3.10648 5.86111C3.28991 5.619 3.6468 5.56293 3.9036 5.73586L5.472 6.79201L7.98958 3.94385C8.19162 3.71529 8.55194 3.68441 8.79438 3.87488Z"
        fill="currentColor"
      />
    </svg>
  );
}
